import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {TargetService, TtdGroup, TtdPartner} from '../../target/target.service';
import {SubscriptionHandler} from '../../utils/subscription-handler';
import {TtdPartnerCreateComponent} from './create/ttd-partner-create.component';
import {TtdPartnerGroupCreateComponent} from './partner-group-create/ttd-partner-group-create.component';

@Component({
  selector: 'app-ttd-partner-config',
  templateUrl: './ttd-partner-config.component.html',
  styleUrls: ['./ttd-partner-config.component.scss']
})
export class TtdPartnerConfigComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort!: MatSort;

  ttdPartner!: Observable<TtdPartner[]>;

  dataSource!: MatTableDataSource<TtdPartner>;

  groups!: TtdGroup[];

  private subscriptionHandler = new SubscriptionHandler();

  constructor(private targetService: TargetService,
              private dialog: MatDialog) {
  }

  ngOnInit() {
    this.fetchPartners();
  }

  ngOnDestroy() {
    this.subscriptionHandler.unsubscribe();
  }

  fetchPartners() {
    // fetch partners and select some of them
    this.ttdPartner = this.targetService.getTtdPartners().pipe(this.selectPartners());
    this.subscriptionHandler.subscription = this.ttdPartner
      .subscribe((ttdPartners) => {
        this.dataSource = new MatTableDataSource<TtdPartner>(ttdPartners);
        this.dataSource.sort = this.sort;
      });

    this.subscriptionHandler.subscription = this.targetService.getTtdGroups().subscribe((groups) => {
      this.groups = groups;
    });
  }

  selectPartners() {
    return map((partners: TtdPartner[]) => partners.filter((p) => p.partnerId !== 'System'));
  }

  ngAfterViewInit() {
  }

  openNewPartnerDialog(): void {
    this.subscriptionHandler.subscription = this.dialog
      .open(TtdPartnerCreateComponent)
      .afterClosed()
      .subscribe(() => this.fetchPartners());
  }

  openNewAgencyDialog(): void {
    this.subscriptionHandler.subscription = this.dialog
      .open(TtdPartnerGroupCreateComponent)
      .afterClosed()
      .subscribe(() => this.fetchPartners());
  }

  groupClick(ttdGroup: TtdGroup, element: TtdPartner, checked: boolean) {
    element.group = checked ? ttdGroup : undefined;
    this.targetService.updateTtdPartner(element).subscribe();
  }
}

